import localforage from 'localforage';
import AuthData from '@/shared/models/auth/auth-data';

interface AppStorageConfig {
  name?: string;
  storeName?: string;
}

interface AppStorage {
  name?: string;
  storeName?: string;
  getItem: LocalForage['getItem'];
  setItem: LocalForage['setItem'];
  removeItem: LocalForage['removeItem'];
  clear: LocalForage['clear'];

  setAuth(authData: AuthData): Promise<void>;

  getAuth(): Promise<AuthData | null>;
}

/**
 * Asynchronous data storage management hook
 *
 * @param {AppStorageConfig} config
 * @return {{storage: LocalForage, store: LocalForage}}
 */
const useStorage = (config?: AppStorageConfig) => {
  const store: AppStorage = {
    ...localforage.createInstance({
      name: config?.name || '@sensei',
      storeName: config?.storeName || 'BACKOFFICE',
      driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB],
    }),
    async setAuth(authData: AuthData) {
      await store.setItem('auth', authData);
    },
    getAuth() {
      return store.getItem('auth') as Promise<AuthData | null>;
    },
  };

  return {
    storage: localforage,
    store,
  };
};

export const getStorage = useStorage;

export default useStorage;
